import React from "react";
import { Button, Form } from "antd";
import { EditOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { SelectWithSearch } from "@comps/components";

const PolicySelectWithActions = (props) => {
  return (
    <Form.Item label={ props.label } className="da-mb-10">
      <div style={ { display: "flex", gap: 8, alignItems: "center" } }>
        <div style={ { flex: 1 } }>
          <Form.Item name={ props.name } rules={ props.rules } noStyle>
            <SelectWithSearch
              placeholder={ props.placeholder }
              options={ props.options }
            />
          </Form.Item>
        </div>
        <Button
          type="default"
          icon={ <PlusOutlined /> }
          onClick={ props.onCreate }
          title={ `Create ${props.buttonLabel}` }
        />
        <Button
          type="default"
          icon={ <EditOutlined /> }
          onClick={ props.onEdit }
          disabled={ !props.selectedValue }
          title={ props.selectedValue ? `Edit ${props.buttonLabel}` : `Select ${props.buttonLabel} first` }
        />
        <Button
          type="default"
          icon={ <EyeOutlined /> }
          onClick={ props.onView }
          disabled={ !props.selectedValue }
          title={ props.selectedValue ? `Preview ${props.buttonLabel}` : `Select ${props.buttonLabel} first` }
        />
      </div>
    </Form.Item>
  );
};

export default PolicySelectWithActions;
